import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import { useTheme } from '../context/ThemeContext';
import { FaMoon, FaSun, FaLock, FaWhatsapp, FaBars } from 'react-icons/fa';
import { FILE_URL } from '../api/axios';

const AdminLayout = ({ children }) => {
    const { darkMode, toggleTheme, settings } = useTheme();
    const user = JSON.parse(localStorage.getItem('user') || sessionStorage.getItem('user'));
    const navigate = useNavigate();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        navigate('/login');
    };

    // Onay Bekliyor Ekranı
    if (user && user.role !== 'admin' && !user.is_active) {
        return (
            <div className="d-flex align-items-center justify-content-center vh-100 bg-light">
                <div className="text-center p-5 bg-white shadow rounded-4" style={{ maxWidth: '500px' }}>
                    <div className="mb-4 text-warning">
                        <FaLock size={64} />
                    </div>
                    <h2 className="fw-bold mb-3">Üyeliğiniz Onay Bekliyor</h2>
                    <p className="text-muted mb-4">Kaydınız başarıyla alındı. Yönetici onayı sonrasında panele erişim sağlayabilir ve sipariş verebilirsiniz. Lütfen daha sonra tekrar kontrol ediniz.</p>
                    <button onClick={handleLogout} className="btn btn-outline-danger">Çıkış Yap</button>
                </div>
            </div>
        );
    }

    const logoSrc = darkMode && settings?.logo_dark 
        ? `${FILE_URL}/${settings.logo_dark}`
        : settings?.logo_light 
            ? `${FILE_URL}/${settings.logo_light}`
            : null;

    return (
        <div className="d-flex" style={{ minHeight: '100vh' }}>
            {/* Mobil Menü Overlay (Siyah Arka Plan) */}
            <div className={`sidebar-overlay ${isSidebarOpen ? 'show' : ''}`} onClick={() => setIsSidebarOpen(false)}></div>

            {/* Sol Menü */}
            <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
            
            {/* İçerik Alanı */}
            <div className="w-100 d-flex flex-column">
                {/* Üst Bar */}
                <div className="d-flex justify-content-between align-items-center p-3 border-bottom bg-card shadow-sm">
                    {/* Mobil Menü Butonu ve Logo */}
                    <div className="d-flex align-items-center d-lg-none gap-3">
                        <button className="btn btn-link p-0 text-body" onClick={() => setIsSidebarOpen(true)}>
                            <FaBars size={24} />
                        </button>
                        {logoSrc ? (
                            <img src={logoSrc} alt="Logo" style={{ maxHeight: '50px' }} />
                        ) : (
                            <h5 className="m-0 fw-bold text-primary">{settings?.site_title || 'VegaMat'}</h5>
                        )}
                    </div>

                    <button onClick={toggleTheme} className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-2">
                        {darkMode ? <><FaSun /> Aydınlık</> : <><FaMoon /> Karanlık</>}
                    </button>
                </div>

                <div className="container-fluid p-4 flex-grow-1">
                    {children}
                </div>
            </div>

            {/* WhatsApp İletişim Butonu */}
            <a 
                href="https://wa.me/32479251212" 
                target="_blank" 
                rel="noopener noreferrer"
                className="position-fixed bottom-0 end-0 m-4 btn btn-success rounded-circle shadow-lg d-flex align-items-center justify-content-center"
                style={{ width: '60px', height: '60px', zIndex: 9999, transition: 'transform 0.3s' }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
                <FaWhatsapp size={35} color="white" />
            </a>
        </div>
    );
};

export default AdminLayout;
